import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'sg-notifications-panel',
  templateUrl: './notifications-panel.component.html',
  styleUrls: ['./notifications-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SgNotificationsPanelComponent implements OnInit {
  filterBy: 'all' | 'alerts' | 'messages' | 'reports' = 'all';

  constructor() {}

  filterByChanged(event: MatSelectChange): void {}

  showOnlyReadChanged(event: MatSlideToggleChange): void {}

  ngOnInit() {}
}
